export const DEFAULT_ZOOM: number = 15;

export const MIN_ZOOM: number = DEFAULT_ZOOM - 3;
